
// import React from "react";
// import { Row, Col, Table, Button } from "react-bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// const getAuthToken = () => {
//   const userData = sessionStorage.getItem("userData");
//   if (!userData) return "";
//   try {
//     const parsed = JSON.parse(userData);
//     return parsed.token || "";
//   } catch {
//     return "";
//   }
// };
// const InvoiceA4 = () => {
//   const data = {
//     company: {
//       name: "SpiceCart Pvt Ltd",
//       logo: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo_TV_2022.svg",
//       address: "12, Aroma Street, Kochi, Kerala, India",
//       email: "support@spicecart.com",
//       phone: "+91 98765 43210",
//     },
//     customer: {
//       name: "Sneha C",
//       address: "22, Green Valley, Bangalore, Karnataka",
//       email: "sneha@example.com",
//     },
//     invoice: {
//       number: "INV-2025-010",
//       date: "23 Oct 2025",
//       due: "30 Oct 2025",
//     },
//     items: [
//       { name: "Turmeric Powder 500g", qty: 2, price: 120 },
//       { name: "Cinnamon Sticks 250g", qty: 1, price: 200 },
//       { name: "Cumin Seeds 1kg", qty: 1, price: 280 },
//     ],
//     taxRate: 0.05,
//   };

//   const subtotal = data.items.reduce((acc, i) => acc + i.qty * i.price, 0);
//   const tax = subtotal * data.taxRate;
//   const total = subtotal + tax;

//   const handlePrint = () => window.print();

//   return (
//     <>
//       <style>{`
//         body {
//           background: #f2f4f7;
//           font-family: "Poppins", sans-serif;
//         }

//         .invoice-page {
//           width: 210mm;
//           min-height: 297mm;
//           background: #fff;
//           margin: 20px auto;
//           padding: 25mm 20mm;
//           border-radius: 12px;
//           box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
//           color: #333;
//         }

//         .invoice-header {
//           border-bottom: 3px solid #0d6efd;
//           padding-bottom: 10px;
//           margin-bottom: 30px;
//         }

//         .invoice-title {
//           font-size: 2rem;
//           font-weight: 700;
//           color: #0d6efd;
//         }

//         .company-info p {
//           margin: 0;
//           font-size: 0.9rem;
//           color: #666;
//         }

//         .bill-to {
//           background: #f8f9fa;
//           border-left: 4px solid #0d6efd;
//           padding: 15px;
//           border-radius: 6px;
//           margin-bottom: 25px;
//         }

//         .bill-to h6 {
//           font-weight: 600;
//           color: #0d6efd;
//         }

//         table {
//           font-size: 0.95rem;
//         }

//         thead {
//           background: linear-gradient(90deg, #0d6efd, #0072ff);
//           color: white;
//         }

//         .total-section {
//           margin-top: 25px;
//           padding: 15px;
//           background: #f8f9fa;
//           border-radius: 8px;
//         }

//         .total-section td {
//           font-size: 1rem;
//         }

//         .grand-total {
//           font-size: 1.4rem;
//           color: #0d6efd;
//           font-weight: 700;
//         }

//         .footer-note {
//           border-top: 2px solid #eee;
//           margin-top: 40px;
//           padding-top: 15px;
//           font-size: 0.85rem;
//           color: #555;
//         }

//         @media print {
//           body {
//             background: white;
//           }
//           .invoice-page {
//             box-shadow: none;
//             margin: 0;
//             border-radius: 0;
//             page-break-after: always;
//           }
//           .btn {
//             display: none !important;
//           }
//         }
//       `}</style>

//       <div className="invoice-page">
//         {/* Header */}
//         <Row className="invoice-header align-items-center">
//           <Col md={8}>
//             <div className="d-flex align-items-center mb-2">
//               <img
//                 src={data.company.logo}
//                 alt="logo"
//                 height="50"
//                 className="me-3"
//               />
//               <div>
//                 <div className="invoice-title">{data.company.name}</div>
//                 <div className="company-info">
//                   <p>{data.company.address}</p>
//                   <p>{data.company.email} | {data.company.phone}</p>
//                 </div>
//               </div>
//             </div>
//           </Col>
//           <Col md={4} className="text-md-end text-center">
//             <h4 className="fw-bold mb-0">INVOICE</h4>
//             <p className="mb-1">No: {data.invoice.number}</p>
//             <p className="mb-1">Date: {data.invoice.date}</p>
//             <p>Due: {data.invoice.due}</p>
//           </Col>
//         </Row>

//         {/* Bill To */}
//         <div className="bill-to">
//           <h6>Bill To:</h6>
//           <p className="mb-1 fw-semibold">{data.customer.name}</p>
//           <p className="mb-0">{data.customer.address}</p>
//           <p className="mb-0">{data.customer.email}</p>
//         </div>

//         {/* Items Table */}
//         <Table bordered responsive className="align-middle text-center">
//           <thead>
//             <tr>
//               <th>Description</th>
//               <th>Qty</th>
//               <th>Unit Price (₹)</th>
//               <th>Total (₹)</th>
//             </tr>
//           </thead>
//           <tbody>
//             {data.items.map((i, idx) => (
//               <tr key={idx}>
//                 <td className="text-start">{i.name}</td>
//                 <td>{i.qty}</td>
//                 <td>{i.price.toFixed(2)}</td>
//                 <td>{(i.qty * i.price).toFixed(2)}</td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>

//         {/* Totals */}
//         <Row className="justify-content-end">
//           <Col md={5}>
//             <Table borderless className="text-end total-section">
//               <tbody>
//                 <tr>
//                   <td>Subtotal:</td>
//                   <td>₹{subtotal.toFixed(2)}</td>
//                 </tr>
//                 <tr>
//                   <td>Tax (5%):</td>
//                   <td>₹{tax.toFixed(2)}</td>
//                 </tr>
//                 <tr className="border-top">
//                   <td className="fw-bold grand-total">Grand Total:</td>
//                   <td className="fw-bold grand-total">₹{total.toFixed(2)}</td>
//                 </tr>
//               </tbody>
//             </Table>
//           </Col>
//         </Row>

//         {/* Footer */}
//         <Row className="footer-note">
//           <Col md={8}>
//             <p>
//               <strong>Payment Info:</strong> UPI: spicecart@upi | Bank: HDFC Bank
//             </p>
//             <p>
//               <strong>Note:</strong> Thank you for your business! Please make
//               the payment before the due date.
//             </p>
//           </Col>
//           <Col md={4} className="text-md-end text-center">
//             <Button variant="primary" onClick={handlePrint}>
//               <i className="bi bi-printer me-2"></i> Print A4 Invoice
//             </Button>
//           </Col>
//         </Row>
//       </div>
//     </>
//   );
// };

// export default InvoiceA4;

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Row, Col, Table, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};

const InvoiceA4 = () => {
  const [orders, setOrders] = useState([]);
  const imageBase = "https://vantara.datacubeglobal.com/storage/";

  useEffect(() => {
    const token = getAuthToken();

    axios
      .get("https://vantara.datacubeglobal.com/api/purchase/history", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setOrders(res.data.data);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  }, []);

  const handlePrint = () => window.print();

  return (
    <>
      <style>{`
        @media screen {
          body {
            background: #f5f7fa;
            padding: 20px;
          }
        }

        .invoice-page {
          width: 210mm;
          min-height: 297mm;
          background: #fff;
          margin: 0 auto;
          padding: 25mm 20mm;
          box-shadow: 0 4px 20px rgba(0,0,0,0.12);
          color: #333;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          position: relative;
        }

        .invoice-header {
          border-bottom: 2px solid #eee;
          padding-bottom: 20px;
          margin-bottom: 25px;
        }

        .invoice-logo {
          font-size: 28px;
          font-weight: 800;
          color: #7B0045;
          margin-bottom: 4px;
        }

        .invoice-meta {
          font-size: 14px;
          line-height: 1.6;
        }

        .invoice-details {
          text-align: right;
        }

        .invoice-details h4 {
          margin-bottom: 8px;
          color: #7B0045;
        }

        thead {
          background: linear-gradient(90deg, #7B0045, #b1006c);
          color: white;
        }

        .grand-total-row {
          font-size: 1.25rem;
          font-weight: 700;
          color: #7B0045;
          border-top: 2px solid #7B0045 !important;
        }

        .print-btn-container {
          text-align: right;
          margin-top: 30px;
        }

        @media print {
          body {
            background: white;
            padding: 0;
          }
          .invoice-page {
            box-shadow: none;
            margin: 0;
            padding: 15mm 15mm;
          }
          .btn-print {
            display: none !important;
          }
        }
      `}</style>

      {orders.length === 0 ? (
        <div className="text-center mt-5">
          <p>No invoices available.</p>
        </div>
      ) : (
        orders.map((order, index) => {
          const subtotal = order.items.reduce(
            (acc, item) => acc + Number(item.total),
            0
          );
          const tax = Number(order.total_tax_amount);
          const total = Number(order.total_amount);

          return (
            <div className="invoice-page" key={index}>
              {/* Header */}
              <div className="invoice-header">
                <Row>
                  <Col md={6}>
                    <div className="invoice-logo">SpiceCart Pvt Ltd</div>
                    <div className="invoice-meta">
                      Kochi, Kerala, India<br />
                      support@spicecart.com | +91 98765 43210
                    </div>
                  </Col>
                  <Col md={6} className="invoice-details">
                    <h4>INVOICE #{order.order_id}</h4>
                    <p className="mb-1">Date: {order.paid_at}</p>
                    <p>Status: <strong>{order.status}</strong></p>
                  </Col>
                </Row>
              </div>

              {/* Items Table */}
              <Table bordered responsive className="text-center align-middle mb-4">
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Product</th>
                    <th>Qty</th>
                    <th>Unit Price (₹)</th>
                    <th>Total (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {order.items.map((item) => (
                    <tr key={item.order_item_id}>
                      <td>
                        <img
                          src={imageBase + item.primary_image}
                          alt={item.name || "Product"}
                          width="60"
                          style={{ borderRadius: "6px", objectFit: "cover" }}
                        />
                      </td>
                      <td className="text-start">{item.name}</td>
                      <td>{item.quantity}</td>
                      <td>₹{Number(item.price).toFixed(2)}</td>
                      <td>₹{Number(item.total).toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {/* Totals */}
              <Row className="justify-content-end">
                <Col md={5}>
                  <Table borderless className="text-end">
                    <tbody>
                      <tr>
                        <td>Subtotal:</td>
                        <td>₹{subtotal.toFixed(2)}</td>
                      </tr>
                      <tr>
                        <td>Tax:</td>
                        <td>₹{tax.toFixed(2)}</td>
                      </tr>
                      <tr className="grand-total-row">
                        <td>Grand Total:</td>
                        <td>₹{total.toFixed(2)}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Col>
              </Row>

              {/* Print Button */}
              <div className="print-btn-container">
                <Button
                  variant="primary"
                  className="btn-print"
                  style={{
                    backgroundColor: "#7B0045",
                    borderColor: "#7B0045",
                    padding: "8px 20px",
                  }}
                  onClick={handlePrint}
                >
                  Print Invoice
                </Button>
              </div>
            </div>
          );
        })
      )}
    </>
  );
};

export default InvoiceA4;